import { TotalRowsFooter } from '../total-rows-footer';
import React, { useState, useCallback } from 'react';
import { Table, TableBody, TableHead } from '@hqo/react-components-library';
import { Instance } from '../../store/instances/types';
import { InstancesTableHeaderRow } from './instances-table-header-row';
import { InstancesTableRow } from './instances-table-row';
import { CopyInstanceModal } from './instances-table-row/copy-instance-modal';

interface InstancesTableProps {
  instances: Instance[];
}

export const InstancesTable = ({ instances }: InstancesTableProps): JSX.Element => {
  const [instanceToCopy, setInstanceToCopy] = useState<Instance | null>(null);

  const handleShowCopyModal = useCallback((instance: Instance) => {
    setInstanceToCopy(instance);
  }, []);

  const handleCloseCopyModal = useCallback(() => {
    setInstanceToCopy(null);
  }, []);

  return (
    <>
      <Table>
        <TableHead>
          <InstancesTableHeaderRow />
        </TableHead>
        <TableBody>
          {instances.map((instance) => {
            if (instance) {
              return <InstancesTableRow key={instance.uuid} instance={instance} onCopy={handleShowCopyModal} />;
            }

            return null;
          })}
        </TableBody>
      </Table>
      <TotalRowsFooter count={instances.length} />
      <CopyInstanceModal instance={instanceToCopy} onClose={handleCloseCopyModal} />
    </>
  );
};
